import { chakra } from '@chakra-ui/react'
import type { Country } from 'commons/constants/countries'
import { authorizedCountryList } from 'commons/constants/countries'
import { BgColors } from 'commons/design-system/tokens'
import type { ChangeEvent } from 'react'

const StyledSelect = chakra('select')

type Props = {
	country: Country
	onChange: (e: ChangeEvent<HTMLSelectElement>) => void
}

export const CountrySelect = ({ country, onChange }: Props) => {
	return (
		<StyledSelect
			w='fit-content'
			pe={1}
			outline={0}
			borderBottom={`1px solid ${BgColors.Z4}`}
			_focus={{ borderBottom: `1px solid ${BgColors.OPPOSITE_Z3}` }}
			value={country.phone}
			onChange={onChange}
		>
			{authorizedCountryList.map((c) => (
				<option key={c.iso} value={c.phone}>
					{c.flag} {c.phone}
				</option>
			))}
		</StyledSelect>
	)
}
